import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Posts from './posts.js';
import fetchSummaries from '../actions/fetch-summaries.js';

const PostsContainer = withRouter(connect(
  (state) => ({
    pageNumber: state.summaries.pageNumber,
    summaries: state.summaries.summaries,
    moreSummariesAvailable: state.summaries.summaries.length < state.summaries.totalSummariesCount 
  }),
  (dispatch) => ({
    fetchSummaries: (pageNumber) => dispatch(fetchSummaries(pageNumber))
  })
)(Posts));

export default PostsContainer;

